'use client';

import React from 'react';
import Image from 'next/image';
import { Inter } from 'next/font/google';

const inter = Inter({ subsets: ['latin'] });

const TestimonialsSection = () => {
    return (
        <section className={`py-12 bg-[#1C1C34] ${inter.className}`} aria-labelledby="testimonials-heading">
            <div className="container mx-auto px-4 md:px-6">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
                    {/* Image Side */}
                    <div className="md:col-span-5">
                        <h2 className="text-l font-normal text-white mb-1">YOU'LL LOVE US</h2>
                        <div className="w-full max-w-[450px] h-[450px] overflow-hidden relative">
                            <Image
                                src="/img/89ac.avif"
                                alt="Customer testimonials"
                                fill
                                className="object-cover"
                                priority
                            />
                        </div>
                    </div>

                    {/* Text Side */}
                    <div className="md:col-span-7">
                        <div className="text-2xl font-normal text-white mb-2 invisible md:visible md:h-0 md:h-8"></div>
                        <h3 id="testimonials-heading" className="text-3xl font-bold text-white mb-4 mt-2 md:mt-0">Why New Yorkers Choose Litty to Book their Parties.</h3>
                        <p className="text-gray-300 mb-8">Real People, Real Parties, Real Easy NYC Venue Finding.</p>

                        <div className="space-y-8">
                            {/* Testimonial 1 */}
                            <div className="pl-0">
                                <p className="text-gray-300 text-base leading-relaxed mb-3">
                                    "It was so easy to find an affordable spot that fit our budget. We booked an amazing rooftop bar for our engagement party"
                                </p>
                                <p className="text-white font-medium">— Chris</p>
                            </div>

                            {/* Testimonial 2 */}
                            <div className="pl-0">
                                <p className="text-gray-300 text-base leading-relaxed mb-3">
                                    "Organizing our company party was simple with Litty's Concierge Team. Booked a great corporate event space stress-free."
                                </p>
                                <p className="text-white font-medium">— Alex</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TestimonialsSection; 